// extracted by mini-css-extract-plugin
export default {"actionSelectIconItem":"IconSelect_actionSelectIconItem__4HgA8"};